/**
 * @file User_AccountActivity.jsx
 *
 * @author - Team D (Meeramol Mathew),TeamE(Keerthana,Karpakam)    
 * @sprint - B2W-Sprint-4
 * @description -
 * This component manages the User Account activity process, including creating, updating,
 * and deleting records.
 *
 */

import React, { useEffect, useState } from "react";
import Layout from "../component/Layout";
import { Button, notification } from "antd";
import { PlusOutlined } from "@ant-design/icons";
import UserCreateEditForm from "../components/AccountActivity/UserCreateEditForm";
import UserListView from "../components/AccountActivity/UserListView";
import axios from "axios";
import { useParams } from "react-router-dom";
import moment from "moment";
import store from "../redux/store";
import { fetchEmployeeData, showErrorNotification, showNotification } from "../util/documentConfig";
import UserAccountActivityLabels from "./UserAccountActivityLabels.json";



const UserAccountActivity = () => {
  const [visible, setVisible] = useState(false); // Manage modal visibility
  const { id } = useParams();
  const [filteredData, setFilteredData] = useState([]);
  const [selectedRecord, setSelectedRecord] = useState(null);
  const [data, setData] = useState([]);
  const [userId, setUserId] = useState(null);
  const email = localStorage.getItem("userEmail");
  const [isAdmin, setIsAdmin] = useState(false);


  const token = store.getState().auth.token;
  if (!token) {
    throw new Error("No token found. User not authenticated.");
  }
  useEffect(() => {
    const roleUser = JSON.parse(localStorage.getItem("userRoles"));

    if (roleUser && roleUser.includes("ADMINUSER")) {
      // alert("setAdmin");
      setIsAdmin(true);
    }

    // If userId is not available, fetch it using email
    if (!id) {
      fetchUserData();
    } else {
      setUserId(id); // Set from URL params
    }
  }, [id]);

  // useEffect(() => {

  //     // If userId is not available, fetch it using email
  //     if (!id) {
  //       fetchUserData();
  //     } else {

  //       setUserId(id); // Set from URL params

  //     }
  //   }); // Depend on id so it updates properly when URL changes




  const fetchUserData = async () => {
    try {
      const fetchedUserId = await fetchEmployeeData(email);
      console.log(`User ID: ${fetchedUserId}`);
      setUserId(fetchedUserId);

    } catch (error) {
      console.error("Failed to fetch userId:", error);
      // showErrorNotification("Failed to fetch userId");
    }
  };


  const fetchData = async () => {
    try {

      const response = await axios.get(`http://localhost:8080/userAccountActivities/${userId}`, {

        headers: {
          'Authorization': `Bearer ${token}`  // Replace `token` with the actual token you want to pass
        }
      });
      console.log("response.....................", response.data);


      // if (response.data && Array.isArray(response.data.accountActivities)) {
      //   setFilteredData(response.data.accountActivities);
      // }

      setFilteredData(response.data);

      if (Array.isArray(response.data)) {
        console.log("response1.....................", response.data); // Log the activities data
        setFilteredData(response.data); // Directly set the data if it's an array
      } else {
        console.warn("No activities found or incorrect structure:", response.data);
        setFilteredData([]); // Ensure state is cleared if no activities are returned
      }
    } catch (error) {

      if (error.response.status === 404) {
        console.warn("No activities found for this user.");
        setFilteredData([]); // Optionally clear data or show a message
      } else {
        console.error("Server responded with an error:", error.response.status);
      }
      // console.error("Error fetching data:", error);
    }
  };

  // Fetch data when component mounts
  useEffect(() => {
    fetchData();
  }, [userId]);


  const onCreate = async (data) => {

    const currentData = {
      ...data,
      userId: userId
    }
    console.log("---------------------data", data);
    try {
      // Send a POST request to save the new activity data
      const response = await axios.post(`http://localhost:8080/userAccountActivities/${userId}`, currentData, {
        headers: {
          'Authorization': `Bearer ${token}`
        },
      });

      // Check if the response is successful (status code 200-299)
      if (response.status >= 200 && response.status < 300) {
        console.log('Activity saved successfully:', response.data);
        showNotification("Activity Added Successfully");
      } else {
        console.error('Failed to save activity:', response);
        showErrorNotification("Failed to save activity");
      }
      fetchData();
    }
    catch (error) {

      if (error.response) {
        if (error.response.status === 409) {
          showErrorNotification("This activity already exists for the user.");
        } else {
          console.error('Error saving activity:', error.response);
          showErrorNotification("Error in Saving Activity");
        }
      } else {
        console.error('Unexpected error saving activity:', error);
        showErrorNotification("Unexpected error occurred.");
      }

    }
  };


  //   const currentData = {
  //     ...data,
  //     userId: userId
  //   };
  //   console.log("---------------------data", data);

  //   try {
  //     const response = await axios.post(`http://localhost:8080/userAccountActivities/${userId}`, currentData, {
  //       headers: {
  //         'Authorization': `Bearer ${token}`
  //       },
  //     });
  // console.log("200/409--------------------------------",response.status);
  // if (response.status >= 200 && response.status < 300) {
  //   console.log('Activity saved successfully:', response.data);
  //   showNotification("Activity Added Successfully");
  // } else if (response.status === 409) {
  //   console.error('Conflict error: Activity already exists');
  //   showErrorNotification("This activity already exists for the user.");
  // } else {
  //   console.error('Failed to save activity:', response);
  //   showErrorNotification("Failed to save activity");
  // }


  //     fetchData(); // Refresh the list of activities after adding
  //   } catch (error) {
  //     if (error.response) {
  //       console.error('Error response:', error.response);

  //       // Specifically handle the 409 Conflict error
  //       if (error.response.status === 409) {
  //         showErrorNotification(error.response.data || "This activity already exists for the user.");
  //       } else {
  //         showErrorNotification(`Error: ${error.response.data.message || 'Unknown error'}`);
  //       }
  //     } else {
  //       showErrorNotification("Error in Saving Activity");
  //     }
  //   }
  // };

  const onDelete = async (record) => {

    if (!record?.id) {
      console.error("❌ No ID found on record");
      return;
    }
    try {

      const response = await axios.delete(`http://localhost:8080/userAccountActivities/${userId}/${record.id}`, {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      });

      fetchData();
      showNotification("Activity Deleted Successfully");
    } catch (error) {
      console.error("Error deleting record:", error);
      /*notification.error({
        message: error.response.data.message,
        description: UserAccountActivityLabels.Failure_Deleted_Message,
        placement: "topRight",
      });*/
      showErrorNotification("Error deleting record:");
    }
  };

  /**
     * Handles opening the edit modal for a record.
     * @param {Object} record - The record to be edited.
     */
  const onEdit = async (record) => {
    console.log("Edit the record: ", record);

    if (!record?.id) {
      console.error("❌ No ID found on record");
      return;
    }
    try {
      const response = await axios.get(`http://localhost:8080/userAccountActivities/${userId}/${record.id}`, {
        responseType: 'json', // Important to handle binary data
        headers: {
          'Authorization': `Bearer ${token}`  // Replace `token` with the actual token you want to pass
        }
      });

      const activity = response.data.accountActivities[0];
      console.log("Editing:-----------", activity);
      // Map to expected structure for form
      const mappedRecord = {
        key: activity.id, // or activity.id if you use that
        activityId: activity.activityId,
        activityName: activity.activityName,
        activity: activity.activityName,
        date: activity.activityDate// parse date for DatePicker
      };

      setSelectedRecord(mappedRecord);
      setVisible(true);
    }
    catch (error) {
      console.error("Error editing record:", error);
      /*notification.error({
        message: error.response.data.message,
        description: UserAccountActivityLabels.Failure_Edit_Message,
        placement: "topRight",
      });*/
      showErrorNotification("Error editing record");
    }


  };

  const onUpdate = async (values, selectedRecord) => {
    // console.log("Form submitted with values:", values);
    // console.log("selected -----------------", selectedRecord);

    const updateData = {
      ...values,
      uid: userId,
      activityId: values.activityId && values.activityId.trim() !== "" ? values.activityId : selectedRecord.activityId,
      activityName: values.activityName && values.activityName.trim() !== "" ? values.activityName : selectedRecord.activityName,
    }
    try {
      // Send PUT request to backend
      await axios.put(`http://localhost:8080/userAccountActivities/${selectedRecord.key}`, updateData, {
        headers: {
          'Authorization': `Bearer ${token}`
        },
      });

      // Show success notification
      /* notification.success({
         message: "Update Successful",
         description: UserAccountActivityLabels.Success_Update_Message,
         placement: "topRight",
         btn: (
           <Button type="primary" size="small" onClick={() => notification.destroy()}>
             {UserAccountActivityLabels.Button_Ok}
           </Button>
         ),
       });*/
      showNotification(UserAccountActivityLabels.Success_Update_Message);

      setSelectedRecord(null); // Reset selected record
      setVisible(false); // Close modal
      fetchData();

    } catch (error) {
      console.error("Error updating record:", error);
      /* notification.error({
         message: "Update Error",
         description: error.response.data.message,
         placement: "topRight",
       });*/
      showErrorNotification("Error updating record");
    }
  };



  return (

    <div className="flex-1 p-6 background-light min-h-screen pt-30">
      {/* Page Heading */}
      {/*} <div className="bg-gray-700 text-white px-4 py-3 rounded-t-md" style={{ backgroundColor: '#1f415b' }}>
        <h1 className="text-lg font-semibold" >{UserAccountActivityLabels.UAA_Title}</h1>
      </div>*/}
      <h1 className="text-2xl text-primary font-bold ml-0">{UserAccountActivityLabels.UAA_Title} </h1>


      {!isAdmin && (
        <div className="flex justify-end mb-4 mr-4">
          <Button
            type="primary"
            icon={<PlusOutlined />}
            onClick={() => {
              setVisible(true); // Show modal on button click
            }}
            className="text-white border p-4 bg-[var(--color-primary)]"
          >
            {UserAccountActivityLabels.Add_Activity_Button}
          </Button>
        </div>
      )}





      {/* Add Activity Button */}
      {/* <div className="flex justify-end mb-4 mr-4">
          <Button
            type="primary"
            icon={<PlusOutlined />}
            
            onClick={() => {
              setVisible(true); // Show modal on button click
            }}
            className="text-white border p-4 bg-[var(--color-primary)]"
          >
            {UserAccountActivityLabels.Add_Activity_Button}
          </Button>
        </div> */}

      {/* Create/Edit Form Modal */}
      {visible && (
        <UserCreateEditForm
          visible={visible}
          setVisible={setVisible}
          onCreate={onCreate}
          onUpdate={onUpdate}
          selectedRecord={selectedRecord}
        />
      )}

      <UserListView data={filteredData} onDelete={onDelete} onEdit={onEdit} />

    </div>

  );
};

export default UserAccountActivity;